import { AppState } from '../../sew-core/types/index';
import { connect, } from 'react-redux';
import ConsumerRatingPanel from '../components/ConsumerRatingPanel';

const mapStateToProps = (state: AppState) => ({
  consumerReviewAndRating: state.consumerReviewAndRating,
  vehicle: state.vehicle
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsumerRatingPanel);
